import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type UseGetTaskCommentsProps = {
  taskId: string
  enabled?: boolean
  projectId: string
}

export const useGetTaskComments = ({
  taskId,
  enabled = true,
  projectId,
}: UseGetTaskCommentsProps) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['taskComments', taskId],
    queryFn: () =>
      projectService.projectTaskComments.getTaskComments({
        taskId,
        projectId,
      }),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar os comentários da tarefa',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      taskComments: data,
      isLoadingGetTaskComments: isLoading,
      refetchTaskComments: refetch,
    }
  }

  return {
    taskComments: [],
    isLoadingGetTaskComments: isLoading,
    refetchTaskComments: refetch,
  }
}
